module.exports = __webpack_public_path__ + "media/images/logos/Harvard-University-604d3f1a19364a36644cb59ebce95e6c.svg";